import React, {useState} from 'react';
import {ContactAdapter} from "../redux/adapters/ContactAdapter";

export function ContactModal() {
    return (
        <>
            <div className="ui basic modal" id={"contactModal"}>
                <i className={"close icon"}></i>
                <ContactAdapter container={"modal"}/>
            </div>
        </>
    )
}

export function ContactPage() {
    return (
        <>
            <ContactAdapter container={"page"}/>
        </>
    )
}
